import { Card } from "@devhop/ui";
import {
  DollarSign,
  FilePenLine,
  FileStackIcon,
  FileText,
  Receipt,
} from "lucide-react";
import type { MyDocumentsCountSummary } from "../lib/my-documents-count-summary";

type MyDocumentsCountSummarySectionProps = {
  summary: MyDocumentsCountSummary;
};

function CountStatCard({
  label,
  value,
  hint,
  icon: Icon,
  iconClassName,
}: {
  label: string;
  value: number;
  hint?: string;
  icon: typeof FileStackIcon;
  iconClassName: string;
}) {
  return (
    <Card className="p-4">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-muted-foreground text-xs">{label}</p>
          <p className="mt-1 font-bold text-2xl tabular-nums leading-none">
            {value.toLocaleString("lo-LA")}
          </p>
          {hint ? (
            <p className="mt-1 text-muted-foreground text-xs leading-snug">
              {hint}
            </p>
          ) : null}
        </div>
        <Icon className={`h-5 w-5 shrink-0 ${iconClassName}`} />
      </div>
    </Card>
  );
}

export function MyDocumentsCountSummarySection({
  summary,
}: MyDocumentsCountSummarySectionProps) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-5">
      <CountStatCard
        label="ເອກະສານທັງໝົດ"
        value={summary.totalDocuments}
        hint="ຮ່າງ + Q / I / R"
        icon={FileStackIcon}
        iconClassName="text-slate-500"
      />
      <CountStatCard
        label="ຮ່າງ"
        value={summary.draftCount}
        icon={FilePenLine}
        iconClassName="text-sky-500"
      />
      <CountStatCard
        label="ໃບສະເໜີລາຄາ"
        value={summary.quotationCount}
        hint="ອອກແລ້ວ"
        icon={DollarSign}
        iconClassName="text-blue-500"
      />
      <CountStatCard
        label="ໃບແຈ້ງໜີ້"
        value={summary.invoiceCount}
        hint="ຄ້າງຊຳລະ"
        icon={FileText}
        iconClassName="text-amber-500"
      />
      <CountStatCard
        label="ໃບຮັບເງິນ"
        value={summary.receiptCount}
        icon={Receipt}
        iconClassName="text-emerald-500"
      />
    </div>
  );
}

export function MyDocumentsCountSummarySectionSkeleton() {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-5">
      {[1, 2, 3, 4, 5].map((i) => (
        <div
          key={i}
          className="animate-pulse rounded-xl border bg-card p-4"
        >
          <div className="h-3 w-24 rounded bg-muted" />
          <div className="mt-3 h-8 w-16 rounded bg-muted" />
        </div>
      ))}
    </div>
  );
}
